import { render } from "./notes-archive.vue?vue&type=template&id=4912d03e&scoped=true&ts=true"
import script from "./notes-archive.vue?vue&type=script&lang=ts"
export * from "./notes-archive.vue?vue&type=script&lang=ts"

import "./notes-archive.vue?vue&type=style&index=0&id=4912d03e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4912d03e"]])

export default __exports__